export const CONTACT_EMAIL = 'sales-vermarktung@enbw.com';
